import { Link } from 'react-router-dom'
import Panel from '../ui/Panel'
import styles from './NotFound.module.css'

export default function NotFound() {
    return (
        <Panel title="404" className={styles.panel}>
            <p>That page does not exist.</p>
            <p className={styles.back}><Link to="/">Back to the leak test</Link></p>
        </Panel>
    )
}
